<template>
  <div class="list-img-container">
    <template v-for="(src, index) in list">
      <img :key="index" v-if="index < limit" v-viewer="list" :src="src | ossStyle(width)" :width="width" alt=""  referrerpolicy="no-referrer" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'ListImg',
  props: {
    img: {
      type: [String, Array],
    },
    limit: {
      type: Number,
      default: 1,
    },
    width: {
      type: Number,
      default: 40,
    },
  },
  computed: {
    list() {
      let temp = [];
      if (!this.img) {
        return temp;
      }
      if (this.img instanceof Array) {
        return this.img;
      }
      if (this.img.indexOf('[') === 0) {
        try {
          temp = JSON.parse(this.img);
        } catch (e) {
          // console.error('img parse error', e);
        }
      } else {
        temp = [this.img];
      }
      return temp;
    },
  },
};
</script>

<style scoped lang="scss">
.list-img-container {
  font-size: 0;

  img {
    vertical-align: middle;
    border-radius: 5px;
  }

  img + img {
    margin-left: 10px;
  }
}
</style>
